import React from 'react';
import styles from './Preloader.module.css';

const Preloader = ({ message = null }) => {
    return (
        <div className={styles.preloaderOverlay}>
            <div className={styles.spinner}></div>
            {message && <p className={styles.message}>{message}</p>}
        </div>
    );
};

export default Preloader;
